module.exports = __webpack_public_path__ + "static/Terminal_GoldMoon.54f2cbce8d8519a7b301a48dc734e135.png";